module.exports = __webpack_public_path__ + "img/chain-block-logo-medium.0546b2de.png";